/* ------------------------------------------------------------------------------
@name: Components Index
@description: Indexing all components
--------------------------------------------------------------------------------- */

import SceneGlobal from "./SceneGlobal";
import Scene1 from "./Scene1";
import Scene2 from "./Scene2";
import Scene4 from "./Scene4";
import Scene5 from "./Scene5";
import Scene6 from "./Scene6";
import Scene7 from "./Scene7";
import Scene8 from "./Scene8";
import Scene11 from "./Scene11";
import Scene12 from "./Scene12";
import Scene18 from "./Scene18";
import Footer from "./footer";

export {
  SceneGlobal,
  Scene1,
  Scene2,
  Scene4,
  Scene5,
  Scene6,
  Scene7,
  Scene8,
  Scene11,
  Scene12,
  Scene18,
  Footer,
};
